import { render } from "./UploadComp.vue?vue&type=template&id=763d7e14&scoped=true&ts=true"
import script from "./uploadHelper.ts?vue&type=script&lang=ts"
export * from "./uploadHelper.ts?vue&type=script&lang=ts"

import "./UploadComp.vue?vue&type=style&index=0&id=763d7e14&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763d7e14"]])

export default __exports__